/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useContext } from 'react';
import {
  Label,
  TeamLogo,
  LargeButton,
  LoginWrapper,
  InputCheckbox,
  TextboxWarning,
  InputComponent,
  TestimonialLogin,
} from '../../components';
import {
  Link,
  Terms,
  Title,
  LabelForm,
  LoginLogo,
  LoginForm,
  FormField,
  RowContainer,
  TermsWrapper,
  LoginLogoSpan,
  CreateAcountWrapper,
} from './styles';
import { Utils } from '../../utils/api';
import { SignUp as SignUpClass } from '../../utils/api/';
import { ARMcontext } from '../../utils/context/context';
import { useInputValue } from '../../utils/hooks/useInputValue';
import { URL_TERMS_LINK, URL_POLICY_LINK } from '../../utils/constants/routes';
import { useLocation, useNavigate } from 'react-router-dom';


export default () => {
  const utils = new Utils();
  const SignUp = new SignUpClass();
  const { HandleDataCreateAccount } = useContext(ARMcontext);

  const location = useLocation();
  const [loading, useLoading] = useState(false);
  const isValidEmail = utils.GetValidationEmailPattern();
  const isValidName = utils.GetValidationWordsWithoutSpecialCharacters();

  const [account] = useState(Object.assign({}, location.state));
  const confirmPassword = useInputValue('', 'eyeClose', '', '', 'password');
  const terms = useInputValue('');
  const password = useInputValue('', 'eyeClose', '', '', 'password');
  const [checkedTerms, setTerms] = useState<boolean>(account['email'] ? true : false);
  const email = useInputValue(account['email'] ? account['email'] : '');
  const lastName = useInputValue(account['lastName'] ? account['lastName'] : '');
  const firstName = useInputValue(account['firstName'] ? account['firstName'] : '');

  function validateData(evt: any): void {
    evt.preventDefault();
    if (!email.value && !lastName.value && !firstName.value && !password.value && !confirmPassword.value) {
      email.HandleWarningTitle('Check all fields');
      email.HandleWarning('It is necessary to fill all the fields');
      email.HandleStatus('error');
    } else if (!firstName.value) {
      firstName.HandleWarningTitle('Fill the name information');
      firstName.HandleWarning('You’ll need your name to sign in to your coach portal');
      firstName.HandleStatus('error');
    } else if (!isValidName.test(firstName.value)) {
      firstName.HandleWarningTitle('Incorrect name');
      firstName.HandleWarning('Please enter a name without special characters');
      firstName.HandleStatus('error');
    } else if (!lastName.value) {
      lastName.HandleWarningTitle('Fill the last name information');
      lastName.HandleWarning('You’ll need your last name to sign in to your coach portal');
      lastName.HandleStatus('error');
    } else if (!isValidName.test(lastName.value)) {
      lastName.HandleWarningTitle('Incorrect last name');
      lastName.HandleWarning('Please enter a last name without special characters');
      lastName.HandleStatus('error');
    } else if (!Boolean(email.value.length)) {
      email.HandleWarningTitle('Fill the email address information');
      email.HandleWarning('You’ll need your address to sign in to your coach portal');
      email.HandleStatus('error');
    } else if (!Boolean(isValidEmail.test(email.value))) {
      email.HandleWarningTitle('Incorrect email');
      email.HandleWarning('Please enter a valid email');
      email.HandleStatus('error');
    } else if (!password.value) {
      password.HandleWarningTitle('Fill the password information');
      password.HandleWarning('You’ll need a password to sign in to your coach portal');
      password.HandleStatus('error');
    } else if (!confirmPassword.value) {
      confirmPassword.HandleWarningTitle('Fill the password information');
      confirmPassword.HandleWarning('Please enter the password again');
      confirmPassword.HandleStatus('error');
    } else if (password.value !== confirmPassword.value) {
      confirmPassword.HandleWarningTitle('Check the passwords');
      confirmPassword.HandleWarning('Passwords are not same');
      confirmPassword.HandleStatus('error');
    } else if (!checkedTerms) {
      terms.HandleWarningTitle('Check the terms and conditions');
      terms.HandleWarning('You need to accept the terms and conditions');
      terms.HandleStatus('error');
    } else {
      HandleCreateAccount();
    }
  }

  async function HandleCreateAccount(): Promise<void> {
    let account = {
      firstName: firstName.value,
      lastName: lastName.value,
      email: email.value,
      password: password.value,
      passwordConfirmation: confirmPassword.value,
    }
    useLoading(true);
    SignUp.Validate(email.value).then((responseValidate: any) => {
      if (responseValidate['valid']) {
        SignUp.AddOrganization(account).then((responseAddOrganization: any) => {
          HandleDataCreateAccount(responseAddOrganization)
          SignUp.Subscriptions(firstName.value, lastName.value, email.value).then((responseSubscriptions: any) => {
            useLoading(false);
            if (responseSubscriptions.success) {
              window.location.replace(responseSubscriptions.url)
            }
          })
        })
      } else {
        useLoading(false);
        if (responseValidate['role'] === 'org-admin') {
          email.HandleStatus('error');
          email.HandleWarningTitle('please use a different email');
          email.HandleWarning('This email belongs to an organization account.');
        } else if (responseValidate['role'] === 'player') {
          email.HandleStatus('error');
          email.HandleWarningTitle('please use a different email');
          email.HandleWarning('This email belongs to a Player account.');
        } else if (responseValidate['role'] === 'coach') {
          email.HandleStatus('error');
          email.HandleWarningTitle('please use a different email');
          email.HandleWarning('This email belongs to a coach account.');
        }
      }
    });
  }

  const HandleFocus = () => {
    let inputs = [firstName, lastName, email, password, confirmPassword, terms];
    inputs.forEach(input => {
      input.HandleWarning('');
      input.HandleStatus('normal');
    })
  }

  const HandleIcon = (hook: any) => {
    if (hook.icon === 'eyeClose') {
      hook.HandleIcon('eyeOpen');
      hook.HandleType('text');
    } else if (hook.icon === 'eyeOpen') {
      hook.HandleIcon('eyeClose');
      hook.HandleType('password');
    }
  }

  const handleCheckbox = () => {
    terms.HandleWarningTitle('');
    terms.HandleWarning('');
    terms.HandleStatus('');
    setTerms(!checkedTerms)
  }

  return (
    <>
      <LoginWrapper isHistory={true} isLoading={loading} topLoader={220}>
        <CreateAcountWrapper>
          <LoginLogo>
            <TeamLogo mWidth="200px" mHeight="40px" />
            <LoginLogoSpan>Measure. Monitor. Optimize</LoginLogoSpan>
          </LoginLogo>
          <LoginForm autoComplete="off" onSubmit={HandleCreateAccount} data-cy="create-account">
            <Title>Create an account</Title>
            <RowContainer>
              <FormField>
                <LabelForm>
                  <Label text="First name" color={'#2B323B'} fontSize={'16px'} fontWeight={'600'} />
                </LabelForm>
                <InputComponent
                  fontSize={16}
                  maxLength={100}
                  disabled={loading}
                  color={'#2B323B'}
                  bordeRadius={'4px'}
                  insetShadow={"#F4F5F7"}
                  dynamicSearch={firstName}
                  placeholder="First name"
                  backgroundColor={'#F4F5F7'}
                  colorPlaceholder={'#D8DDE3'}
                  HandleFocus={() => HandleFocus()}
                />
                <TextboxWarning status={firstName.status} title={firstName.warningTitle} message={firstName.warningMessage} />
              </FormField>
              <FormField>
                <LabelForm>
                  <Label text="Last name" color={'#2B323B'} fontSize={'16px'} fontWeight={'600'} />
                </LabelForm>
                <InputComponent
                  fontSize={16}
                  maxLength={100}
                  color={'#2B323B'}
                  disabled={loading}
                  bordeRadius={'4px'}
                  placeholder="Last name"
                  dynamicSearch={lastName}
                  insetShadow={"#F4F5F7"}
                  backgroundColor={'#F4F5F7'}
                  colorPlaceholder={'#D8DDE3'}
                  HandleFocus={() => HandleFocus()}
                />
                <TextboxWarning status={lastName.status} title={lastName.warningTitle} message={lastName.warningMessage} />
              </FormField>
            </RowContainer>
            <FormField width={'100%'}>
              <Label text="Email" color={'#2B323B'} fontSize={'16px'} fontWeight={'600'} />
              <InputComponent
                fontSize={16}
                color={'#2B323B'}
                disabled={loading}
                bordeRadius={'4px'}
                dynamicSearch={email}
                insetShadow={"#F4F5F7"}
                placeholder="your@email.com"
                backgroundColor={'#F4F5F7'}
                colorPlaceholder={'#D8DDE3'}
                HandleIcon={() => HandleIcon(email)}
                HandleFocus={() => HandleFocus()}
              />
              <TextboxWarning status={email.status} title={email.warningTitle} message={email.warningMessage} />
            </FormField>
            <RowContainer>
              <FormField>
                <Label text="Password" color={'#2B323B'} fontSize={'16px'} fontWeight={'600'} />
                <InputComponent
                  fontSize={16}
                  disabled={loading}
                  bordeRadius={'4px'}
                  color={'#2B323B'}
                  dynamicSearch={password}
                  insetShadow={"#F4F5F7"}
                  autoComplete="new-password"
                  placeholder="Password here"
                  backgroundColor={'#F4F5F7'}
                  colorPlaceholder={'#D8DDE3'}
                  HandleFocus={() => HandleFocus()}
                  HandleIcon={() => HandleIcon(password)}
                />
                <TextboxWarning status={password.status} title={password.warningTitle} message={password.warningMessage} />
              </FormField>
              <FormField>
                <Label text="Confirm Password" color={'#2B323B'} fontSize={'16px'} fontWeight={'600'} />
                <InputComponent
                  color={'#2B323B'}
                  fontSize={16}
                  disabled={loading}
                  bordeRadius={'4px'}
                  insetShadow={"#F4F5F7"}
                  dynamicSearch={confirmPassword}
                  backgroundColor={'#F4F5F7'}
                  colorPlaceholder={'#D8DDE3'}
                  autoComplete="new-password"
                  placeholder="Confirm password here"
                  HandleFocus={() => HandleFocus()}
                  HandleIcon={() => HandleIcon(confirmPassword)}
                />
                <TextboxWarning status={confirmPassword.status} title={confirmPassword.warningTitle} message={confirmPassword.warningMessage} />
              </FormField>
            </RowContainer>
            <TermsWrapper>
              <InputCheckbox onClick={handleCheckbox} checked={checkedTerms} />
              <Terms>
                By creating an account you agree to our <Link target="_blank" href={URL_TERMS_LINK}> Terms of Service Conditions</Link> and <Link target="_blank" href={URL_POLICY_LINK}>Privacy Policy</Link>
              </Terms>
            </TermsWrapper>
            <FormField width={'100%'}>
              <TextboxWarning status={terms.status} title={terms.warningTitle} message={terms.warningMessage} />
            </FormField>
            <LargeButton
              fullWidth
              lMargin="0"
              type="submit"
              fSize={'16px'}
              bradius={'8px'}
              title="Continue"
              rColor="#006BE1"
              disabled={loading}
              dataCy="login-button"
              callback={validateData}
              xMargin={'32px 0 0;'}
              colorDisabled={'#B3D7FF'}
            />
          </LoginForm>
        </CreateAcountWrapper>
        <TestimonialLogin />
      </LoginWrapper>
    </>
  );
};
